import { render } from "./ProcedureComponent.vue?vue&type=template&id=f5bbfae6&scoped=true"
import script from "./ProcedureComponent.vue?vue&type=script&lang=js"
export * from "./ProcedureComponent.vue?vue&type=script&lang=js"

import "./ProcedureComponent.vue?vue&type=style&index=0&id=f5bbfae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5bbfae6"]])

export default __exports__